export const permissionTree = [
    {
        key: 'admin_view',
        title: 'Admin View',
        children: [
            { key: 'company', title: 'Company Management' },
            {
                key: 'user', title: 'User Management'
            },
            {
                key: 'profile', title: 'Profile Management'
            },
            {
                key: 'certify_request_menu', title: 'CertifyRequest',
            },
            {
                key: 'facility', title: 'Facility Management'
            },

            { key: 'admin_settings_menu', title: 'Settings' },
            { key: 'admin_benchmark_menu', title: 'Benchmark' },
            { key: 'admin_template_menu', title: 'Template', children: [
                { key: 'equipmentCategory', title: 'Equipment Category' },
                { key: 'functionform', title: 'Functional Form' },
            ] },
        ]
    },
    {
        key: 'facility_view',
        title: 'Facility View',
        children: [
            {
                key: 'dashboard_menu',
                title: 'Dashboard',
            },
            {
                key: 'utility_menu',
                title: 'Utility',
                children: [
                    { key: 'summary_menu', title: 'Summary' },
                    { key: 'electricity', title: 'Electricity' },
                    { key: 'gas', title: 'Gas'},
                    { key: 'savings_menu', title: 'Savings' },
                    { key: 'certify_menu', title: 'Certify' },
                ]
            },
            {
                key: 'equipment_folder_menu',
                title: 'Equipment Management',
                children: [
                    { key: 'equipment', title: 'Equipment'},
                    { key: 'functiontesting', title: 'Function Testing' },
                ]
            },
            {
                key: 'benchmark', title: 'Benchmark Analysis'
            },

            { key: 'workorder', title: 'Work Order'},
            { key: 'project', title: 'Project Management' },
            { key: 'log', title: 'System Logs' },
            { key: 'customreport', title: 'Custom Reports' },
            { key: 'filemanage', title: 'File Management' },
        ]
    },
    {
        key: 'portfolio_view',
        title: 'Portfolio View',
        children: [
            { key: 'portfolio_dashboard_menu', title: 'Portfolio Dashboard' },
        ]
    }
];